import { googletag } from "./shared"
import { getOrCreateStatus, getFullPath } from "./status"
import { ADS } from "./constants"

export const initializeAd = (key) => {
  const ad = ADS[key]
  const status = getOrCreateStatus(key)
  const container = document.getElementById(ad.id)

  if (!container || !container.clientHeight || status.initialized) {
    return
  }

  const { id, sizes } = ad
  const path = getFullPath(status.activePath)

  googletag.cmd.push(function () {
    if (ad.sizeMapping) {
      const mapping = googletag.sizeMapping()
      ad.sizeMapping.forEach((size) => {
        mapping.addSize(size[0], size[1])
      })

      const builtMapping = mapping.build()

      status.slot = googletag
        .defineSlot(path, sizes, id)
        .setTargeting(id, "true")
        .defineSizeMapping(builtMapping)
        .addService(googletag.pubads())
    } else {
      status.slot = googletag.defineSlot(path, sizes, id).setTargeting(id, "true").addService(googletag.pubads())
    }
  })
  status.initialized = true
  return status
}

export const initializeAds = () => {
  Object.keys(ADS).forEach((key) => {
    const ad = ADS[key]
    if (ad.skipInitializationOnPageLoad) {
      return
    }

    initializeAd(key)
  })
}

initializeAds()
